import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm'
import WeatherTemplateSchema from 'schemas/weatherTemplate.schema.json'
import { useAppContext } from 'hooks/useAppContext'
import { getDomainsForState, updateReportTemplate } from 'utils/ProjectConfigurationUtil'
import { useFormContext } from 'hooks/useFormContext'
import SkeletonForm from 'components/Shared/SkeletonForm'
import { useFormikContext } from 'formik'
import deepEql from 'deep-eql';
import { useCanDoAction } from 'hooks/useCanDoAction'

const WeatherTemplate = ({ orientation, defaultValues: _defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {

    const { selectedProject, selectedProjectData } = useAppContext();
    const [schamaState, setSchemaState] = useState(true);
    const [filteredDomains, setFilteredDomains] = useState([]);
    const [defaultValues, setDefaultValues] = useState(_defaultValues);
    const [readOnlyState, setReadOnlyState] = useState({readOnly: true, readOnlyEdit: true});
    const formContext = useFormContext();
    const canUpdate = useCanDoAction('ProjectConfig', 'update');

    useEffect(() => {
        setDefaultValues(_defaultValues);
    }, [_defaultValues]);

    useEffect(() => {
        !deepEql(defaultValues, _defaultValues) ? setReadOnlyState({readOnlyEdit: canUpdate, readOnly: false}) : setReadOnlyState({readOnlyEdit: canUpdate, readOnly: true});
    }, [defaultValues, _defaultValues, canUpdate]);

    useEffect(() => {
        schamaState && formContext.updateSchema(WeatherTemplateSchema);
        setSchemaState(false);
    }, [schamaState, formContext]);

    // contact specific CRUD functions
    const onSubmit = async (values) => {
        let result;
        if (CRUDType === "UPDATE") {
            result = await updateReportTemplate(selectedProject, defaultValues, values);
            setTimeout(callback, 1000)
        }
        return result
    };

    const FormikHitchHiker = () => {
        const { values } = useFormikContext();
        useEffect(() => {
            const asyncEffect = async () => {
                const { stateId } = values;
                const _domains = await getDomainsForState(stateId);
                if(!deepEql({...formContext.definitions, ..._domains}, filteredDomains)) {
                    setFilteredDomains({...formContext.definitions, ..._domains});
                };

                if(!deepEql({...defaultValues, ...values}, defaultValues)) {
                    setDefaultValues(old => ({...old, ...values}));
                };
            };
            asyncEffect();
        }, [values])

        return null;
    };

    const WeatherForm = ({children}) => withExtension(DynamicForm, { schema: WeatherTemplateSchema, orientation, onSubmit,
        defaultValues, disabledProperties, hiddenProperties, definitions: filteredDomains, children, ...readOnlyState, title: false });


    return (
        selectedProjectData && formContext.ready ?
            <WeatherForm><FormikHitchHiker></FormikHitchHiker></WeatherForm> :
            <SkeletonForm />
    )
}

WeatherTemplate.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

WeatherTemplate.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}


export default WeatherTemplate;
